// // Entry point for the build script in your package.json
// import "@hotwired/turbo-rails"
// import "./controllers"

console.log("application.js loaded")

import setupApp from "./src/index"

// Initialize Active Storage
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

window.onload = () => {
  if (document.getElementById("app")) setupApp()
}
